<template>
  <main
    :class="[
      {'content-layout--with-side-menu': menuOpened},
      {'content-layout--hide-navbar': !showNavbar},
      {'content-layout--with-agents-bar': !$route.name.toLowerCase().includes('statistic')
        && isAgent }
    ]"
    class="content-layout"
  >
    <notifications group="common" />
    <router-view />
    <StatusModal />
  </main>
</template>
<script>
import { mapState } from 'pinia';
import StatusModal from '@/components/modals/StatusModal.vue';
import { useRootStore } from '@/stores/root';

export default {
  name: 'ContentLayout',
  components: {
    StatusModal,
  },
  props: {
    menuVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      isAgent: false,
    };
  },
  computed: {
    ...mapState(useRootStore, [
      'menuOpened',
      'showNavbar',
      'agent',
    ]),
  },
  watch: {
    agent(newVal) {
      this.isAgent = !!newVal;
    },
  },
};
</script>
<style lang="scss">

  .content-layout {
    transition: padding-left .33s ease-in-out;
    background-color: $grey-layout;
    display: flex;
    flex: 1 0 auto;
    max-width: 100%;
    padding-top: 60px;
    padding-left: 0px;

    &--with-side-menu{
      @include desktop {
        padding-left: 260px;
      }
    }

    &--hide-navbar {
      padding-top: 0px;
      z-index: 26;
    }

    &--with-agents-bar {
      padding-top: 102px;
    }

  }

</style>
